import { useAppDispatch } from './useAppStore';
import { showSnackbar, type SnackSeverity } from '../store/snackbarSlice';

export function useAppSnackbar() {
  const dispatch = useAppDispatch();
  return (message: string, severity: SnackSeverity = 'info') => {
    dispatch(showSnackbar({ message, severity }));
  };
}
